<template>
  <div>
    <div style="padding: 15px 15px; background-color: #ffffff; color: black">
      <div v-if="detail.arr.length > 0" class="detail-namea">
        <div style="text-align: left">
          <div v-for="item in detail.arr" :key="item">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="detail">
        <div style="box-sizing: border-box">
          <div>
            <div class="detail-name">
              <div style="width: 30%; line-height: 32px; text-align: center">
                套餐名称
              </div>
              <div
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  line-height: 32px;
                  text-align: center;
                  width: 70%;
                  color: #409eff;
                "
              >
                {{ detail.displayName }}
              </div>
            </div>
            <div class="detail-name">
              <div style="width: 30%; line-height: 32px; text-align: center">
                套餐流量
              </div>
              <div style="line-height: 32px; text-align: center; width: 70%">
                <span v-if="detail.imaginaryQuantity > 1024">
                  {{ detail.imaginaryQuantity / 1024 }}G
                  <!-- 9999999999M -->
                </span>
                <span v-else>
                  {{ detail.imaginaryQuantity / 1024 }}G
                  <!-- 9999999999M -->
                </span>
              </div>
            </div>

            <div class="detail-name">
              <div style="width: 30%; line-height: 32px; text-align: center">
                生效时间
              </div>
              <div style="text-align: center; width: 70%">
                <van-radio-group
                  style="margin-top: 5px"
                  v-model="detail.next"
                  @change="changess"
                  direction="horizontal"
                >
                  <div
                    style="display: flex; width: 100%; justify-content: center"
                  >
                    <van-radio :name="false">{{detail.validityType==0?'立即生效':'本月生效'}}</van-radio>
                    <van-radio v-if="detail.nexts == true" :name="true">
                      次月生效
                    </van-radio>
                  </div>
                </van-radio-group>
                <!-- <el-radio-group
               
                
                v-model="detail.next"
              >
                <el-radio :label="false">立即生效</el-radio>
                <el-radio
                  style="height: 32px"
                  v-if="detail.nexts == true"
                  :label="true"
                >
                  次月生效
                </el-radio>
              </el-radio-group> -->
              </div>
            </div>
            <div
              class="detail-name"
              v-if="detail.couponPrice > 0"
              style="border-bottom: 0"
            >
              <div style="width: 100%; color: red; text-align: center">
                原价{{ detail.price }}元。已自动使用赠送金立减{{
                  detail.couponPrice
                }}元
              </div>
            </div>

            <div
              v-if="po"
              style="width: 100%; height: 150px; background-color: #777777"
            ></div>
          </div>
        </div>
      </div>
      <!-- 支付类型 -->
      <div class="detail" style="margin-bottom: 0">
        <van-radio-group v-model="posType" @change="changeRadio">
          <div
            class="bcg-item"
           
          >
            <div class="detail-names" style="border-bottom: 0;">
              <div class="display-left">
                <img
                  class="img"
                  src="../assets/前端/微信图片_20210606190140.png"
                  alt=""
                />
                <span style="margin-left: 10px">余额支付</span>
              </div>
              <van-radio class="display-right" :name="0"></van-radio>
            </div>
            <div class="bottomBox">
              <div class="itemBox">
                <div
                  v-for="(item, index) in price"
                  :key="index"
                  :class="
                    activeBalance == item.prestoreMoney
                      ? 'activeItems'
                      : 'items'
                  "
                  @click="Recharge(item)"
                >
                  <div class="tuijian" v-if="item.recommend == 1">推荐充值</div>
                  <span class="title">
                    {{ item.prestoreMoney }}
                    <span class="danwei">元</span>
                  </span>
                  <span class="daozhang">
                    到账:{{ item.giveMoney + item.prestoreMoney }}元
                  </span>
                  <!-- <div class="positionItem" v-if="balanceData.activeBalance==item.balance">
										<img class="chooseIcon" src="@/static/img/homeImage/del.png" mode=""></img>
									</div> -->
                </div>
                <div style="width: 22%; height: 0px"></div>
                <div style="width: 22%; height: 0px"></div>
                <div style="width: 22%; height: 0px"></div>
                <div style="width: 22%; height: 0px"></div>
              </div>
            </div>
          </div>
          <div v-if="detail.seriesModel.prestore == false">
            <div
              v-for="(item, index) in newPayList"
              :key="item.name"
              class="bcg-item"
              :style="{
                border: index + 1 == newPayList.length ? '0' : '',
              }"
            >
              <div class="detail-names">
                <div class="display-left">
                  <img class="img" :src="item.imageUrl" alt="" />
                  <span style="margin-left: 10px">{{ item.name }}</span>
                  <div v-if="qqs == true" class="recommend">
                    <div v-if="item.systemRecommend == 1" class="recommends">
                      推荐
                    </div>
                  </div>
                  <div v-else class="recommend">
                    <div v-if="item.appRecommend == 1" class="recommends">
                      推荐
                    </div>
                  </div>
                </div>
                <van-radio class="display-right" :name="item.id"></van-radio>
              </div>
            </div>
          </div>
        </van-radio-group>
      </div>
      <div class="jisuVipBox" v-if="detail.seriesModel.speedMembershipList&&detail.seriesModel.speedMembershipList.length==1">
        <span class="tips">购买极速会员，让网速更快</span>
        <img
          class="imageBoxs"
          @click="setCheck"
          :src="detail.seriesModel.speedMembershipList[0].path?detail.seriesModel.speedMembershipList[0].path:require('@/assets/vip.jpg')"
        ></img>
        <div class="yBox" v-if="detail.speedShow">
          已选中
        </div>
      </div>
      <div class="vipBoxNew" v-if="detail.seriesModel.speedMembershipList&&detail.seriesModel.speedMembershipList.length>1">
        <div v-for="item  in  detail.seriesModel.speedMembershipList" :key="item.id" style="width: 47%;">
          <div class="vipBoxNew-item">
            <img
          class="imageBoxNew"
          @click="setChecks(item)"
          :src="item.path?item.path:require('@/assets/vip.jpg')"
        ></img>
        <div class="yBoxNew" v-if="item.id==detail.vipForm.id && detail.speedShow==true">
          已选中
        </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div
        v-if="detail.vipForm"
        style="background-color: #fbf5e5; margin-top: -1px; color: #5d5443"
      >
        <div
          style="
            text-align: left;
            color: #5d5443;
            font-size: 17px;
            font-weight: 1000;
            padding: 10px 25px;
          "
        >
          {{ detail.vipForm.title }}
        </div>
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding-bottom: 5px;
            align-items: center;
            padding-right: 10px;
          "
        >
          <div
            style="
              display: flex;
              justify-content: start;
              align-items: center;
              width: 250px;
            "
          >
            <img
              style="
                width: 15px;
                height: 15px;
                margin-left: 25px;
                margin-right: 5px;
              "
              src="@/assets/16528bbc9914c51d4dda64a536464c2.png"
              alt=""
            />
            <div
              @click="showTitle(detail.vipForm.content)"
              style="
                font-size: 14px;
                white-space: nowrap;
                overflow: hidden;
                text-align: left;
                text-overflow: ellipsis;
              "
            >
              {{ detail.vipForm.content }}
            </div>
          </div>
          <van-checkbox
            icon-size="18px"
            label-position="left"
            shape="square"
            @change="changesse"
            v-model="detail.speedShow"
            checked-color="#dac48d"
          >
            <span style="color: #dac48d; font-size: 14px">
              ￥{{ detail.vipForm.money }}元/ {{detail.vipForm.day  }}天
            </span>
          </van-checkbox>
        </div>
        <div
          v-if="detail.vipForm.name"
          style="
            width: 100%;
            padding-bottom: 15px;
            text-align: left;
            padding-left: 25px;
            display: flex;
            font-size: 14px;
            box-sizing: border-box;
          "
        >
          <van-checkbox
            icon-size="18px"
            shape="square"
            v-model="detail.isRead"
            checked-color="#dac48d"
            @change="setChecka"
          ></van-checkbox>
          <div
            style="
              width: 320px;
              margin-left: 10px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            "
          >
            我已阅读并同意
            <span style="color: #409eff" @click="readShow = true">
              《{{ detail.vipForm.name }}》
            </span>
            相关条款
          </div>
        </div>
      </div>
      <div
        style="
          width: 100%;
          background-color: #ffffff;
          color: #000000;
          margin-top: -1px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 25px;
          box-sizing: border-box;
          padding-right: 45px;
        "
      >
        <div style="color: #c1bcaf">
          总计：
          <span style="color: #dac48d; font-size: 18px">
            ￥{{
             comPrice
            }}
          </span>
        </div>
        <div>
          <van-button
            @click="newPos(posType)"
            style="
              width: 100%;
              background-color: #dac48d;
              border: 1px solid #dac48d;
              color: #76693e;
              font-weight: 600;
              height: 30px;
            "
            size="small"
            type="info"
            round
          >
            确认支付
          </van-button>
        </div>
      </div>
    </div>
    <div v-if="detail.vipForm">
      <van-dialog
        v-if="detail.vipForm.name"
        v-model="readShow"
        :title="detail.vipForm.name"
        show-cancel-button
        confirmButtonText="同意"
        cancelButtonText="拒绝"
        @cancel="detail.isRead = false"
        @confirm="detail.isRead = true"
      >
        <div v-html="detail.vipForm.protocolContent"></div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
  import vipImgs from "@/assets/vip.jpg";
  import { getPayList, sendSetMeal, addOrders } from "@/api/newPay";
  import { getTime, prestoreGetAll } from "@/api/cardOperation";
  export default {
    name: "Tals",
    props: ["detail", "fom", "type"],
    data() {
      return {
        vipMoney:'',
        vipId:'',
        vipForm:{},
        activeBalance: "",
        readShow: false,
        adasdasd: {},
        numsa: "",
        codes: "",
        //支付环境
        enm: 1,
        //新支付列表
        newPayList: [],
        //新支付商户
        newPayListItem: [],
        //商户弹窗
        posShow: false,
        //商户类型
        posType: 1,
        //选中支付商户id
        radio: "",
        // 支付商户appId
        appId: "",
        ss: false,
        card: "",
        show: false,
        showfg: false,
        value: "",
        orderObj: {},
        showKeyboard: true,
        po: false,
        pay: "",
        showse: false,
        val: "",
        zhifu: [],
        weixin: [],
        zhifubao: [],
        yinlian: [],
        leshua: [],
        tongguan: [],
        code: "",
        nums: 1000,
        qqs: "",
        showss: false,
        imagerurl: "",
        satrtTime: "",
        endTime: "",
        nextss: "",
        ssss: "",
        plok: 0,
        arr: [],
        fu: 0,
        fuBei: [],
        namesa: "",
        contents: "",
        price: [],
        payListNew:[],
        rechargeBalance:[]
      };
    },
    async created() {
      if (this.detail.seriesModel.timeAlert == 1) {
        this.detail.next = "";
      }
      this.detail.isRead = true;
      this.numsa = this.detail.couponEndPrice;
      await this.is_weixn();
      await this.getPayList();
      // Loading.service();
    },
    mounted() {
      if (this.detail.seriesModel.timeAlert == 1) {
        this.detail.next = "";
      }
      if (this.detail.seriesModel.prestore == true) {
        this.posType = 0;
      }
      this.detail.isRead = true;
    },

    methods: {
      setChecka(){
        this.detail.isRead=!this.detail.isRead
      },
      
      //极速会员选择
      setCheck(){
        this.detail.speedShow=!this.detail.speedShow
        this.price = this.rechargeBalance.filter(obj => (obj.prestoreMoney + obj.giveMoney) >= this.comPrice) // 筛选出num大于等于threshold的对象
							.sort((a, b) => a.prestoreMoney - b.prestoreMoney).splice(0, 4) // 按num排序
              console.log(this.price)
              console.log(this.rechargeBalance)
      },
       //极速会员选择
       setChecks(val){
        this.detail.vipForm=val
        this.detail.speedShow=true
        this.price = this.rechargeBalance.filter(obj => (obj.prestoreMoney + obj.giveMoney) >= this.comPrice) // 筛选出num大于等于threshold的对象
							.sort((a, b) => a.prestoreMoney - b.prestoreMoney).splice(0, 4) // 按num排序
              console.log(this.price)
              console.log(this.rechargeBalance)
      },
      //切换支付
      changeRadio() {
        if (this.posType != 0) {
          this.activeBalance = "";
        } else {
          if(this.activeBalance==''){
            if(this.detail.cardBalance<this.comPrice)
            this.activeBalance = this.price[0].prestoreMoney;
          }

        }
      },
      //选中余额
      Recharge(val) {
        this.posType = 0;
        if (this.activeBalance == val.prestoreMoney) {
          this.activeBalance = "";
        } else {
          // balanceData.detail = val;
          this.activeBalance = val.prestoreMoney;
          // balanceData.detailShow = true
        }
      },
      //获取新支付列表
      getPayList() {
        getPayList(this.enm).then((res) => {
          res.data.forEach((item) => {
            item.list.forEach((items) => {
              items.imgUrl = item.imageUrl;
            });
          });
          prestoreGetAll().then((res) => {
            if (res.status) {
              this.rechargeBalance=res.data
              this.price = res.data.filter(obj => (obj.prestoreMoney + obj.giveMoney) >= this.comPrice) // 筛选出num大于等于threshold的对象
							.sort((a, b) => a.prestoreMoney - b.prestoreMoney).splice(0, 4) // 按num排序
							
            }
          });
          this.payListNew=res.data
          if (this.detail.balancePayment == 1) {
            this.posType = 0;
            this.newPayList = [];
          } else {
            if (res.data.length > 0) {
              this.payType = res.data[0].id;
            } else {
              this.payType = 0;
            }
            this.newPayList = res.data;
          }
        });
      },
      showTitle(val) {
        this.$toast(val);
      },
      //选择支付商户
      newPos(val) {
        if (this.detail.seriesModel.timeAlert == 1 && this.fu == 0) {
          this.$toast.fail("请选择生效时间");
        } else {
          if (this.detail.isRead == true) {
            if (val == 0) {
              let balanceObj = {
                id: this.detail.id,
                show: true,
                next: this.detail.next,
                shows: this.detail.speedShow,
                balance:this.comPrice,
                type:this.activeBalance,
                newPayList: this.payListNew,
                vipId:this.detail.speedShow==true?this.detail.vipForm.id:'',
                vipMoney:this.detail.speedShow==true?this.detail.vipForm.money:0,
              };
              this.$emit("balanceShow", balanceObj);
            } else {
              if (
                this.detail.planModel &&
                this.detail.planModel.balanceMarket != "" &&
                this.detail.planModel.balanceMarket != null &&
                this.detail.planModel.balanceMarket != "<p><br></p>" &&
                localStorage.getItem("balanceshow") == undefined
              ) {
                this.$emit("planAlertse", {
                  show: true,
                  shows: this.detail.speedShow,
                });
              } else {
                this.newPayList.forEach((item) => {
                  if (item.id == val) {
                    let payObj = {
                      id: this.detail.id,
                      newPayListItem: item.list,
                      radio: item.list[0].id,
                      posShow: true,
                      next: this.detail.next,
                      posType: this.posType,
                      shows: this.detail.speedShow,
                      vipId:this.detail.speedShow==true?this.detail.vipForm.id:'',
                      vipMoney:this.detail.speedShow==true?this.detail.vipForm.money:0,
                    };
                    this.$emit("payShow", payObj);
                    //商户列表
                    // this.newPayListItem = item.list;
                    //首选
                    // this.radio = this.newPayListItem[0].id;
                    //商户弹唱
                    // this.posShow = true;
                  }
                });
              }
            }
          } else {
            this.$toast.fail(
              `请先阅读并勾选《${this.detail.vipForm.name}》相关条款`
            );
          }
        }
      },
      //拉起支付
      sendSetMeal(mealId, payId, code, next, payType, val,vipId) {
        sendSetMeal(mealId, payId, code, next, payType, val,vipId).then((res) => {
          if (res.status) {
            if (res.data.payType == 2) {
              window.location.href = res.data.body;
            } else if (res.data.payType == 3) {
              console.log(res.data.body);
              this.imagerurl = `/app/qrcode/qrcode?content=${encodeURIComponent(
                res.data.body
              )}`;
              console.log(this.imagerurl);
              this.showss = true;
            }
          } else {
            this.$toast(res.msg);
          }
        });
      },
      //确认支付
      confirmPay() {
        localStorage.removeItem("next");
        localStorage.setItem("next", this.detail.next);
        localStorage.removeItem("meal");
        localStorage.setItem("meal", this.detail.id);
        this.newPayListItem.forEach((item) => {
          if (this.radio == item.id) {
            this.codes = item.code;
            this.appId = item.appId;
          }
        });

        if (this.isWeiXin() == true && this.codes == 0 && this.posType == 1) {
          this.wx(null, 1, this);
        } else {
          this.sendSetMeal(
            Number(localStorage.getItem("meal")),
            this.radio,
            "",
            this.detail.next,
            "MWEB",
            this.detail.speedShow,
            this.detail.speedShow==true?this.detail.vipForm.id:""
          );
        }
      },
      is_weixn() {
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          this.enm = 3;
          return (this.qqs = true);
        } else {
          this.enm = 2;
          return (this.qqs = false);
        }
      },
      plmo() {
        this.showfg = false;
        this.plok = 1;
      },
      weixinSDK(appid, timeStamp, package2, nonceStr, paySign, type, payType) {
        function onBridgeReady() {
          window.WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: appid,
              timeStamp: timeStamp,
              nonceStr: nonceStr,
              package: package2,
              signType: type,
              paySign: paySign,
              payType: payType,
            },
            function (res) {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                alert("充值成功");
              } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("取消充值");
              } else if (res.err_msg == "get_brand_wcpay_request:fail") {
                alert("充值失败");
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      },
      wx(code, type, than) {
        function jumpLink() {
          const url = encodeURIComponent(
            window.location.protocol +
              "//" +
              window.location.host +
              "/weixinRedirect/" +
              localStorage.getItem("meal") +
              `?card=${localStorage.getItem("meCardNum")}&payId=${
                than.radio
              }&next=${localStorage.getItem(
                "next"
              )}&flags=${localStorage.getItem("flag")}&vipId=${than.detail.vipForm.id}&biaoShi=${than.detail.a}`
          );

          window.location.href =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            than.appId +
            "&response_type=code&scope=snsapi_userinfo&redirect_uri=" +
            url;
        }
        getUserInfo();

        function getUserInfo() {
          if (code != null && code != undefined && code.trim() != "") {
            var s = "";
            if (than.isWeiXin() == true) {
              s = "JSAPI";
            } else {
              s = "MWEB";
            }
            sendSetMeal(
              Number(localStorage.getItem("meal")),
              than.$route.query.payId,
              code,
              than.$route.query.next,
              s,
              than.$route.query.flags,
              than.$route.query.vipId
            ).then((res) => {
              if (res.status) {
                var obj = {};
                obj = res.data.body;

                than.weixinSDK(
                  obj.appId,
                  obj.timeStamp,
                  obj.package,
                  obj.nonceStr,
                  obj.sign,
                  obj.signType,
                  s
                );
              } else {
                than.$toast(res.msg);
              }
            });
          } else {
            if (type == 1) {
              jumpLink();
            }
          }
        }
      },

      isWeiXin() {
        undefined;
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          undefined;
          return true;
        } else {
          undefined;
          return false;
        }
      },
      changesse() {
        if (this.detail.speedShow==true) {
          this.numsa =
            this.detail.couponEndPrice +
            this.detail.seriesModel.speedMembershipList[0].money;
        } else {
          this.numsa =
            this.detail.couponEndPrice -
            this.detail.seriesModel.speedMembershipList[0].money;
        }
      },

      changess() {
        // if (this.detail.next == "") {
        //   console.log("111");
        // } else {
        if (this.detail.seriesModel.timeAlert == 1 && this.detail.next !== "") {
          if (this.detail.next != 5) {
            this.fu = 0;
            var ssex = this.$toast.loading({
              message: "正在获取时间...",
              forbidClick: true,
              loadingType: "spinner",
              duration: 2000,
            });
            getTime(this.detail.id, this.detail.next)
              .then((res) => {
                if (res.status) {
                  ssex.clear();
                  let obj = {
                    showfg: true,
                    satrtTime: res.data.addTime,
                    endTime: res.data.endTime,
                  };
                  this.$emit("dateOpen", obj);
                  this.fu = 1;
                } else {
                  this.$dialog
                    .confirm({
                      message: res.msg,
                      confirmButtonText: "立即实名",
                      closeOnClickOverlay: false,
                    })
                    .then(() => {
                      this.$router.push({
                        name: "Register",
                        params: {
                          type: this.type,
                        },
                      });
                    })
                    .catch(() => {});
                }
              })
              .catch((res) => {
                console.log(res);
                this.fu = 0;
              });
          }
        }
        // }
      },

      // confirm() {
      //   localStorage.removeItem("next");
      //   localStorage.setItem("next", this.detail.next);
      //   localStorage.removeItem("meal");
      //   localStorage.setItem("meal", this.detail.id);
      //   this.zhifu.forEach((item) => {
      //     if (this.radio == item.id) {
      //       this.appId = item.appId;
      //     }
      //   });
      //   if (this.val == "微信支付通道") {
      //     localStorage.removeItem("qqm");
      //     if (this.isWeiXin() == false) {
      //       this.axios
      //         .get(
      //           `/app/payWeixin/weixinSetMeal?card=${localStorage.getItem(
      //             "meCardNum"
      //           )}&mealId=${Number(localStorage.getItem("meal"))}&payId=${
      //             this.radio
      //           }&code=${""}&next=${this.detail.next}&payType=${"MWEB"}`
      //         )
      //         .then((res) => {
      //           if (res.data.status) {
      //             window.location.href = res.data.data.body;
      //           } else {
      //             this.$toast(res.data.msg);
      //           }
      //         });
      //     } else {
      //       this.wx(null, 1, this);
      //     }
      //   } else if (this.val == "支付宝支付通道") {
      //     this.axios
      //       .get(
      //         `/app/payZhifubao/zhifubaoSetMeal?card=${localStorage.getItem(
      //           "meCardNum"
      //         )}&mealId=${this.detail.id}&payId=${this.radio}&next=${
      //           this.detail.next
      //         }`
      //       )
      //       .then((res) => {
      //         if (res.data.status) {
      //           if (this.qqs == false) {
      //             window.location.href =
      //               "alipays://platformapi/startapp?saId=10000007&clientVersion=3.7.0.0718&qrcode=" +
      //               res.data.data.body;
      //           } else {
      //             this.imagerurl = `/app/qrcode/qrcode?content=${res.data.data.body}`;
      //             this.showss = true;
      //           }
      //         } else {
      //           this.$toast(res.data.msg);
      //         }
      //       });
      //   } else if (this.val == "银联支付通道") {
      //     this.axios
      //       .get(
      //         `/app/ylPay/payMeal?card=${localStorage.getItem(
      //           "meCardNum"
      //         )}&mealId=${this.detail.id}&payId=${this.radio}&next=${
      //           this.detail.next
      //         }`
      //       )
      //       .then((res) => {
      //         if (res.data.status) {
      //           window.location.href = res.data.data.body;
      //         } else {
      //           this.$toast(res.data.msg);
      //         }
      //       });
      //   } else if (this.val == "乐刷支付通道") {
      //     localStorage.removeItem("qqm");
      //     localStorage.setItem("qqm", "乐刷支付通道");
      //     this.wx(null, 1, this);
      //   } else if (this.val == "通莞支付通道") {
      //     localStorage.removeItem("qqm");
      //     localStorage.setItem("qqm", "通莞支付通道");
      //     this.wx(null, 1, this);
      //   } else if (this.val == "付呗支付通道") {
      //     this.axios
      //       .get(
      //         `/app/payFuBei/fuBeiSetMeal?card=${localStorage.getItem(
      //           "meCardNum"
      //         )}&mealId=${this.detail.id}&payId=${this.radio}&next=${
      //           this.detail.next
      //         }`
      //       )
      //       .then((res) => {
      //         if (res.data.status) {
      //           window.location.href = res.data.data.body;
      //         } else {
      //           this.$toast(res.data.msg);
      //         }
      //       });
      //   } else {
      //     this.axios
      //       .get(
      //         `/app/payqq/qqSetMeal?card=${localStorage.getItem(
      //           "meCardNum"
      //         )}&mealId=${this.detail.id}&payId=${this.radio}&next=${
      //           this.detail.next
      //         }`
      //       )
      //       .then((res) => {
      //         if (res.data.status) {
      //           if (this.qqs == false) {
      //             window.location.href =
      //               "mqqapi://forward/url?url_prefix=" +
      //               window.btoa(res.data.data.body) +
      //               "&souce=oicqzone.com&version=1&src_type=web";
      //           } else {
      //             this.imagerurl = `/app/qrcode/qrcode?content=${res.data.data.body}`;
      //             this.showss = true;
      //           }
      //         } else {
      //           this.$toast(res.data.msg);
      //         }
      //       });
      //   }
      // },
      //余额支付
      balancePay() {
        if (this.value === "") {
          this.$toast.fail("密码不能为空");
        } else {
          var st = this.$toast.loading({
            message: "正在支付中，请稍后...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 0,
          });
          this.orderObj.setmealId = this.detail.id;
          this.orderObj.meCardNum = localStorage.getItem("meCardNum");
          this.orderObj.payPassWord = Number(this.value);
          addOrders(
            this.orderObj.setmealId,
            this.orderObj.payPassWord,
            this.orderObj.payType,
            this.detail.next == false ? 0 : 1,
            this.detail.speedShow
          )
            .then((res) => {
              if (res.status) {
                st.clear();
                this.show = false;
                // this.card = this.$route.params.card;
                this.$dialog
                  .alert({
                    message: res.msg,
                  })
                  .then(() => {
                    // on close
                  });
                this.value = "";
                localStorage.removeItem("next");
              }
            })
            .catch(() => {
              let s = res.msg;
              if (s == "账号余额不足") {
                this.$dialog
                  .confirm({
                    message:
                      "账户余额小于要支付的套餐金额点击确认跳转余额充值界面",
                  })
                  .then(() => {
                    this.$router.push(`/recharge`);
                  })
                  .catch(() => {
                    // on cancel
                  });
              } else {
                this.$dialog
                  .alert({
                    message: s,
                  })
                  .then(() => {
                    // on close
                  });
              }
              localStorage.removeItem("next");
            });
        }
      },

      shows(val) {
        if (this.fu == 0) {
          this.$toast.fail("请选择生效时间");
        } else {
          this.orderObj.payType = val;
          this.show = true;
        }
      },
      tishi() {
        if (this.po == true) {
          this.po = false;
        } else {
          this.po = true;
        }
      },
    },
    computed:{
                //计算价格
      comPrice(){
        if(this.posType==0){
          if(this.activeBalance!=''){
            return this.activeBalance
          }else{
            if(this.detail.speedShow==true){
              return Math.floor(
                (this.detail.couponEndPrice +
                this.detail.seriesModel.speedMembershipList[0].money
                  ) * 100
              ) / 100
            }else{
              return Math.floor(
                (this.detail.couponEndPrice 
                  ) * 100
              ) / 100
            }
          }
        }else{
          if(this.detail.speedShow==true){
              return Math.floor(
                (this.detail.couponEndPrice +
                this.detail.seriesModel.speedMembershipList[0].money
                  ) * 100
              ) / 100
            }else{
              return Math.floor(
                (this.detail.couponEndPrice 
                  ) * 100
              ) / 100
            }
        }
      },
            },
    watch: {
      detail: {
        handler(oldVal,newVal) {
          console.log(1,oldVal)
          console.log(2,newVal);
          if (this.detail.seriesModel.timeAlert == 1) {
            this.detail.next = "";
          }
          this.detail.seriesModel.prestore = newVal.seriesModel.prestore;
          this.detail.balancePayment = newVal.balancePayment;
          this.numsa = newVal.couponEndPrice;
          this.getPayList();
          // this.detail.next = 5;
          this.fu = 0;
        },
      },
      fom: {
        handler(newVal) {
          this.adasdasd = newVal;
          if (newVal.speedMemberEndTime) {
            this.detail.speedShow = false;
          } else {
            this.detail.speedShow = true;
          }
        },
      },
    },
 

  };
</script>
<style>
  .van-dialog {
    color: #000000 !important;
  }
</style>

<style lang="scss" scoped>
.vipBoxNew{
  display: flex;
  justify-content: space-between;
  background: #f5f5f5;
  box-sizing: border-box;
  flex-wrap: wrap;
  border-radius: 10px;
  margin: 15px 0;
  padding: 15px;
  padding-top: 0;
  .vipBoxNew-item{
    margin-top: 15px;
    width: 100%;
    position: relative;
    .imageBoxNew {
      width: 100%;
      height: 160px;
      border-radius: 5px;
    }

    .yBoxNew {
      width: 74px;
      height: 31px;
      background-color: #ffcc6b;
      color: #fff;
      font-size: 13px;
      text-align: center;
      line-height: 31px;
      border-radius: 5px 0px 5px 0px;
      position: absolute;
      bottom: 2px;
      right: 0px;
    }
  }
}
  .jisuVipBox {
    width: 100%;
    margin-top: 10px;
    background-color: #fff;
    border-radius: 10px;
    padding: 6px 28px;
    box-sizing: border-box;
    position: relative;

    .tips {
      display: inline-block;
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #ff0a00;
    }

    .imageBoxs {
      margin-top: 10px;
      width: 100%;
      height: 160px;
    }

    .yBox {
      width: 74px;
      height: 31px;
      background-color: #ffcc6b;
      color: #fff;
      font-size: 13px;
      text-align: center;
      line-height: 31px;
      border-radius: 5px 0px 5px 0px;
      position: absolute;
      bottom: 8px;
      right: 27px;
    }
  }
  .bcg-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row; //横向布局
    flex-wrap: wrap;
    border-bottom: 1px solid rgba(128, 128, 128, 0.1);
  }
  .bottomBox {
    width: 100%;
    margin-top: 4px;
     margin-bottom: 4px;
    padding-left: 30px;
    box-sizing: border-box;
    height: auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .itemBox {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .noticeBox {
      width: 100%;
      margin-top: 10px;
      padding: 6px 8px;
      box-sizing: border-box;
      border: 1px solid #ffcc6b;
      border-radius: 5px;
      background-color: #fef5e4;
      display: flex;
      align-items: center;

      .noticeIcon {
        width: 12px;
        height: 12px;
      }

      .tips {
        color: #f7ba1e;
        font-size: 12px;
        line-height: 12px;
        margin-left: 4px;
      }
    }

    .activeItems {
      width: 22%;
      height: 64px;
      border-radius: 5px;
      border: 1px solid #ffcc6b;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;

      .tuijian {
        width: auto;
        border-radius: 5px 0px 5px 0px;
        padding: 2px 6px;
        box-sizing: border-box;
        color: #fff;
        background-color: #ffcc6b;
        font-size: 9px;
        line-height: 10px;
        position: absolute;
        top: 0px;
        left: 0px;
      }

      .title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #000000;

        .danwei {
          font-weight: 500 !important;
          font-size: 16px;
          color: #000000;
        }
      }

      .positionItem {
        width: 13px;
        height: 13px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0px;
        bottom: 0px;
        border-radius: 3px 0px 3px 0px;
        background-color: #ffcc6b;

        .chooseIcon {
          width: 10px;
          height: 10px;
          display: inline-block;
          margin-top: 4px;
          margin-left: 2px;
        }
      }

      .daozhang {
        width: 100%;
        margin-top: 4px;
        text-align: center;
        font-size: 11px;
        color: #86909c;
      }
    }

    .items {
      width: 22%;
      height: 64px;
      border-radius: 5px;
      border: 1px solid #e5e6eb;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;

      .tuijian {
        width: auto;
        border-radius: 5px 0px 5px 0px;
        padding: 2px 6px;
        box-sizing: border-box;
        color: #fff;
        background-color: #ffcc6b;
        font-size: 9px;
        line-height: 10px;
        position: absolute;
        top: 0px;
        left: 0px;
      }

      .title {
        width: 100%;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #000000;

        .danwei {
          font-weight: 500 !important;
          font-size: 16px;
          color: #000000;
        }
      }

      .daozhang {
        width: 100%;
        margin-top: 4px;
        text-align: center;
        font-size: 11px;
        color: #86909c;
      }
    }
  }
  :deep(.van-dialog) {
    color: #009fff !important;
  }

  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border-top: 1px solid rgba(#009fff, 0.2);
  }
  .img {
    width: 22px;
    height: 22px;
    vertical-align: middle;
  }

  .display-left {
    width: 50%;
    display: flex;
    align-items: center;
    justify-self: left;
  }
  .recommend {
    display: flex;
    align-items: center;
    width: 27px;
  }
  .recommends {
    background: #ffca66;
    color: #ffffff;
    width: 27px;
    text-align: center;
    font-size: 9px;
    height: 15px;
    border-radius: 3px;
  }
  .display-right {
    display: flex;
    align-items: center;
    width: 45%;
    justify-content: flex-end;
  }
  .detail {
    width: 100%;
    justify-content: space-between;
    background: #f5f5f5;
    box-sizing: border-box;
    border-radius: 10px;
    margin: 15px 0;

    .detail-name {
      display: flex;
      align-content: center;
      font-size: 14px;
      padding: 10px;
      height: 30px;
      text-align: center;
      border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    }

    .detail-names {
      display: flex;
      align-content: center;
      justify-content: space-between;
      font-size: 14px;
      height: 30px;
      padding: 10px;
      text-align: left;
      border-bottom: 1px solid rgba(128, 128, 128, 0.1);
      width: 100%;
    }

    .detail-names:last-child {
      display: flex;
      align-content: center;
      justify-content: space-between;
      font-size: 14px;
      height: 30px;
      padding: 10px;
      text-align: left;
      border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    }
  }

  .detail-namea {
    font-size: 16px;
    padding: 10px;
    background: #f8f8f8;
    border-radius: 10px;
  }

  .content:last-child {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 10px;
    color: black;
    font-size: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(#009fff, 0.2);
  }
</style>
